import axios from '../utils/axios';

export default function createSeekerSubscription(adminId,data) {
    return (
        axios.post('/admin/' + adminId + '/manageSeekerSubscriptions/v2/admin/createNewPurchase', data )
    )
}
